import { ajaxSetup, fetchSetup, requestManager } from '@devexpress/analytics-core/analytics-utils';

/**
 * Adjunta el JWT a TODAS las peticiones de DevExpress Reporting (visor /DXXRDV, diseñador /DXXRD
 * y query builder /DXXQB) usando el request manager basado en FETCH.
 *
 * ¿Por qué fetch y no ajax (jQuery)? Con el manager jQuery (ajaxSetup) la previsualización lleva
 * el header, pero la EXPORTACIÓN/IMPRESIÓN del visor cae internamente a un `new XMLHttpRequest()`
 * crudo (dx-webdocumentviewer: _prepareXhr/_executeXhr) que NO aplica los headers de ajaxSettings:
 * el POST /DXXRDV de exportación salía SIN Authorization y el backend (AuthorizeLIS) respondía 401
 * ("An error occurred during the export"), sin abrir el diálogo de impresión. El camino de
 * exportación por fetch (_printUsingBlobFetch -> getExportResult -> FetchRequestManager) SÍ aplica
 * fetchSettings.headers, así que la impresión queda autenticada igual que la preview.
 *
 * OJO con el singleton: el requestManager de DevExpress se crea una sola vez (getInstance NO
 * re-inicializa si ya existe). Si un visor previo lo creó como Ajax, con solo setear fetchSettings
 * NO se cambia y, al limpiar ajaxSettings, se pierde el header también en la preview. Por eso aquí
 * se fuerza la re-inicialización como Fetch con requestManager.initialize({ fetchSetup }).
 * (DevExpress prohíbe configurar ajaxSetup y fetchSetup a la vez, por eso además se limpia
 * ajaxSettings.) Se llama con el token vigente (de Redux) justo antes de renderizar el
 * visor/diseñador; al mutar el mismo objeto fetchSettings, el token se refresca en cada render.
 */
export const setDxReportingAuth = (token?: string | null) => {
  fetchSetup.fetchSettings = {
    headers: {
      ...(token ? { Authorization: token } : {}),
    },
  };

  // Desactiva el manager jQuery para evitar el error "más de un request manager" si algo intentara
  // re-inicializar leyendo ambos setups.
  (ajaxSetup as unknown as { ajaxSettings?: unknown }).ajaxSettings = undefined;

  // Fuerza el manager Fetch aunque el singleton ya se hubiera creado como Ajax en un render previo.
  requestManager.initialize({ fetchSetup });
};
